import {ProviderMetricsPageAction} from "./ProviderMetricsPage";
import React, {Dispatch} from "react";
import {ProviderMetricsFilterValue} from "./domain";
import {formatDate} from "../../../common/util/date";
import CancelIcon from "@material-ui/icons/Cancel";
import {SPLIT_DELIMITER} from "../../../placement/const";
import {ProviderMetricsReportTypeMap} from "../domain";

type ProviderMetricsFilterBadgeProps = {
    filter: ProviderMetricsFilterValue;
    dispatch: Dispatch<ProviderMetricsPageAction>
}

const ProviderMetricsFilterBadge = ({filter, dispatch}: ProviderMetricsFilterBadgeProps) => {
    let values: Array<string> = [];
    if (filter.reportType && ProviderMetricsReportTypeMap.has(filter.reportType)) {
        values = values.concat(`Report Type: ${ProviderMetricsReportTypeMap.get(filter.reportType)}`);
    }
    if (filter.reportPeriod) {
        values = values.concat(`Report Period: ${formatDate(filter.reportPeriod, 'MMMM/yyyy')}`);
    }
    if (filter.reportAvailableDateFrom) {
        values = values.concat(`Report Available Date From: ${formatDate(filter.reportAvailableDateFrom)}`);
    }

    if (filter.reportAvailableDateTo) {
        values = values.concat(`Report Available Date To: ${formatDate(filter.reportAvailableDateTo)}`);
    }
    if (values.length === 0) {
        return <div/>;
    }

    const updateFilterByRemoveValue = (value: string) => {
        if (value) {
            if (value.includes("Report Type:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportType: ""}});
                return;
            }
            if (value.includes("Report Period:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportPeriod: null}});
                return;
            }
            if (value.includes("Report Available Date From:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportAvailableDateFrom: null}});
                return;
            }
            if (value.includes("Report Available Date To:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportAvailableDateTo: null}});
                return;
            }
        }
    }

    return (
        <div className='flex pl-5 items-start'>
            <div className='pt-2 pr-5 flex-grow-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {value}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>);
}

export default ProviderMetricsFilterBadge;